import Log from "web-sdk";

import { Console } from "./console";

type IPageInfoList = Array<{
  path: string;
  curr_page: string;
  brand: string;
  business1: string;
  business2: string;
  event_tracking: string;
  event_tracking_id: string;
  event_tracking_ext: {
    usr_language: string;
  };
}>;

let userLang: string;
let pageInfoList: IPageInfoList;
const baseURL = "https://log.noxiaohao.com";

const webName = "mph_web";

const brand = "morphism";
const business1 = "morphism";
const business2 = "website";

const pathnames = {
  "/": "mph_web_explorer",
};

const events = {
  // testnet explorer
  testnet_explorer_page: "b4301",
  mph_web_explorer: "b4301",
  mph_web_hoodi_explorer: "b4301",
  "testnet_explorer_blocks:_click": "b4306",
} as const;

export type LogEventKey = keyof typeof events;

const isLogDisabled = (): boolean => {
  if (typeof window === "undefined") return true;
  if (
    ["Devnet", "Qanet", undefined].includes(
      process.env.NEXT_PUBLIC_NETWORK_TYPE,
    )
  ) {
    return true;
  }
  if (window.location.hostname === "localhost") return true;
  if (window.location.origin.startsWith("http://localhost")) return true;
  return false;
};

export const log = ({ page = "mph_web_explorer" }: { page: string }) => {
  if (isLogDisabled()) return;

  // @ts-ignore
  userLang = navigator.language || navigator.userLanguage;

  pageInfoList = [
    {
      path: "",
      curr_page: "/",
      brand,
      business1,
      business2,
      event_tracking: `${webName}_${page}`,
      event_tracking_id: `${events[page as LogEventKey] || ""}`,
      event_tracking_ext: {
        usr_language: userLang,
      },
    },
  ];

  return new Log(
    {
      app_id: "xyz.morphism.pc",
      app_name: webName,
    },
    pageInfoList,
    {
      baseURL,
    },
  );
};

export const websiteTabClick = ({
  event,
  page = "mph_web_explorer",
}: {
  event: string;
  page?: string;
}) => {
  if (isLogDisabled()) return;

  page =
    pathnames[location.pathname as keyof typeof pathnames] || pathnames["/"];

  try {
    log({
      page,
    })?.click({
      business1,
      business2,
      event_tracking: `${webName}_${event}`,
      event_tracking_id: events[event as LogEventKey],
      event_tracking_ext: {
        user_language: userLang,
      },
    });
  } catch (err) {
    Console.log(
      `websiteTabClick ${event} ${events[event as LogEventKey]}`,
      err,
    );
  }
};
